import React from 'react';
import { Container } from './Card.styles';

interface CardProps {
  children?: React.ReactNode;
  className?: string;
}

const Card = ({ children, className }: CardProps) => {
  return <Container className={className}>{children}</Container>;
};

export default Card;
